import { CartObject } from "../cart/CartObject";
import { Guid } from "guid-typescript";
import { SessionCustomerAddress } from "./SessionCustomerAddress";
import { CartItem } from "../cart/CartItem";
import { RestaurantInformation } from "./RestaurantInformation";
import { SessionCustomerInfo } from "./SessionCustomerInfo";

export class SessionObject {
    static readonly ORDER_TYPE_DELIVERY = "delivery";
    static readonly ORDER_TYPE_PICKUP = "pickup";
    static readonly DELIVERY_TIME_ASAP = "ASAP";

    sessionId: string;
    orderType: "pickup" | "delivery";
    orderDate: string;
    futureOrderTimestamp:number | undefined;
    expirationTime: number;
    cart: CartObject;
    restaurantInformation: RestaurantInformation | undefined;
    customerInfo: SessionCustomerInfo | undefined;
    customerAddress: SessionCustomerAddress | undefined;

    isSessionValid:boolean;

    //One restaurant mode - the customer can't see the other restaurants
    isOneRestaurantMode:boolean

    constructor(id: string, expiration: number, cart: CartObject, orderType: "pickup" | "delivery", orderDate: string, futureOrderTimestamp:number | undefined, 
        restaurantInformation: RestaurantInformation | undefined, customerInfo: SessionCustomerInfo | undefined, customerAddress: SessionCustomerAddress | undefined,
         isSessionValid:boolean, isOneRestaurantMode:boolean) {
        this.sessionId = id;
        this.expirationTime = expiration;
        this.cart = cart;
        this.orderType = orderType;
        this.orderDate = orderDate;
        this.futureOrderTimestamp = futureOrderTimestamp;
        this.restaurantInformation = restaurantInformation;
        this.customerInfo = customerInfo;
        this.customerAddress = customerAddress;
        this.isSessionValid = isSessionValid;
        this.isOneRestaurantMode = isOneRestaurantMode
    }

    isAddressDefined() {
        return this.customerAddress != null &&
            this.customerAddress.lat != null &&
            this.customerAddress.lng != null &&
            this.customerAddress.address != null;
    }

    clearCart(expirityDateTime: number) {
        this.cart.clear();
        this.updateExpirityDateAndInvalidateSession(expirityDateTime);
    }
    addItemToCart(cartItemId: string, addedItem: CartItem, expirityDateTime: number) {
        //Special character string...
        if(addedItem.title.startsWith("%ic")){
            addedItem.title = addedItem.title.substr(3);
        }
        this.cart.setItemInCart(cartItemId, addedItem, (this.orderType == SessionObject.ORDER_TYPE_DELIVERY));
        this.updateExpirityDateAndInvalidateSession(expirityDateTime);
    }
    removeItemFromCart(cartItemId: string[], expirityDateTime: number) {
        this.cart.removeItemFromCart(cartItemId, (this.orderType == SessionObject.ORDER_TYPE_DELIVERY));
        this.updateExpirityDateAndInvalidateSession(expirityDateTime);
    }


    /** Updates the expirity time of this session, with the  a new expirtyDate timestamp  */
    updateExpirityDateAndInvalidateSession(expirityDate: number) {
        this.isSessionValid = false;
        this.expirationTime = expirityDate;
    }

    /** Converts this object into a format that can be saved on our database (DynamoDB) */
    toAwsObject() {
        let sessionObj: any = {
            sessionId: this.sessionId,
            orderType: this.orderType,
            orderDate: this.orderDate,
            expirationTime: this.expirationTime,
            cart: this.cart.toAwsObject(),
            isOneRestaurantMode:this.isOneRestaurantMode
        };

        sessionObj["restaurantInformation"] = (this.restaurantInformation != undefined) ? this.restaurantInformation.toAwsObject() : {};
        sessionObj["customerInfo"] = (this.customerInfo != undefined) ? this.customerInfo.toAwsObject() : {};
        sessionObj["customerAddress"] = (this.customerAddress != undefined) ? this.customerAddress.toAwsObject() : {};
        
        if(this.futureOrderTimestamp != null){
            sessionObj["futureOrderTimestamp"] = this.futureOrderTimestamp;
        }

        return sessionObj;
    }

    /**
     *  Generates a new expirity date for this object - a timestamp X days from now
     * @param daysUntilExpiration How many days until this session expires
     */
    // static getNewExpirityDate(daysUntilExpiration: number): number {
    //     return moment().add(daysUntilExpiration,'day').unix();
    // }

    /** Generates a new, empty, template SessionObject */
    static generateNew(expirityDate: number, orderType?:'pickup'|'delivery') {
        
        const ordType = orderType!=null?orderType:this.ORDER_TYPE_DELIVERY;

        return new SessionObject(
            //We use a GUID as an ID. Google it. Almost impossible to have a duplicate value!
            Guid.create().toString(),
            //Expirity time will be today + DAYS_UNTIL_EXPIRATION
            expirityDate,
            CartObject.generateNewCartObj(),
            ordType, this.DELIVERY_TIME_ASAP,
            undefined, undefined, undefined, undefined,
            false, false
        )
    }

    /** Uses the data received from DynamoDB to create a new Session Object */
    static newfromAwsData(awsData: any) {
        return new SessionObject(
            awsData.sessionId,
            awsData.expirationTime,
            CartObject.newFromAws(awsData.cart),
            awsData.orderType,
            awsData.orderDate,
            awsData.futureOrderTimestamp,
            RestaurantInformation.newfromAwsData(awsData.restaurantInformation),
            SessionCustomerInfo.newFromAws(awsData.customerInfo),
            SessionCustomerAddress.newFromAws(awsData.customerAddress),
            awsData.isSessionValid,
            awsData.isOneRestaurantMode
        );
    }
}